import { Flex } from '@everlywell/ui-kit';
import InputField from 'components/FormFields/InputField';
import SelectField from 'components/FormFields/SelectField';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export const BIRTH_ASSIGNED_SEX_OBJ = {
  male: { id: 'M', value: 'Male' },
  female: { id: 'F', value: 'Female' },
};

const BIRTH_ASSIGNED_SEX_OPTIONS = [
  BIRTH_ASSIGNED_SEX_OBJ.male,
  BIRTH_ASSIGNED_SEX_OBJ.female,
];

export type PersonalDataFormProps = {};

export type PrePurchaseQuizPersonalData = {
  personalData: {
    age: number;
    sex: string;
  };
};

/**
 * This component adds the personal data form fields to the pre-purchase quiz modal.
 */
function PersonalDataForm(props: PersonalDataFormProps): JSX.Element {
  const { register } = useFormContext();

  // TODO: move content to contentful and fetch it from there
  return (
    <Flex flexDirection="column" gap={3} marginTop={[4, 6]}>
      <Flex flexDirection={['column', null, 'row']} gap={4}>
        <InputField
          label="Age"
          min="0"
          name="personalData.age"
          placeholder="Enter Age"
          ref={register}
          type="number"
          validations={{ required: 'age is a required field' }}
        />
        <SelectField
          aria-label="Select Sex"
          label="Current anatomy"
          name="personalData.sex"
          options={BIRTH_ASSIGNED_SEX_OPTIONS}
          placeholder="Select Sex"
          ref={register}
          renderOption={({ id: abbr, value: name }) => (
            <option key={abbr} value={abbr}>
              {name}
            </option>
          )}
          validations={{
            required: 'Current anatomy is a required field',
          }}
        />
      </Flex>
    </Flex>
  );
}

export default PersonalDataForm;
